export enum VehicleFuelType {
  DIESEL,
  PETROL,
}

export enum VehicleFuelLabelType {
  DIESEL = 'Diesel',
  PETROL = 'Petrol',
}
